import _slicedToArray from "/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useReducer as t, useRef as n, useCallback as r, useLayoutEffect as e, useEffect as o, useState as c } from "react";
var i = "undefined" == typeof window || /ServerSideRendering/.test(window.navigator && window.navigator.userAgent) ? o : e;

function u(e, u, a, s) {
  var d = function () {
    var _c = c(function () {
      return new AbortController();
    }),
        _c2 = _slicedToArray(_c, 2),
        t = _c2[0],
        r = _c2[1],
        e = n(t);

    return o(function () {
      return function () {
        e.current.abort(), e.current = new AbortController(), r(e.current);
      };
    }, []), t.signal;
  }(),
      l = s || a,
      _t = t(e, u, s && a),
      _t2 = _slicedToArray(_t, 2),
      w = _t2[0],
      g = _t2[1],
      p = n(w);

  i(function () {
    p.current = w;
  }, [w]);
  var f = r(function () {
    return p.current;
  }, []),
      b = r(function (t) {
    var _ref = t || {},
        n = _ref.type,
        r = n && l[n] || null;

    r ? r({
      dispatch: b,
      getState: f,
      signal: d
    })(t) : g(t);
  }, [l, f, d]);
  return [w, b];
}

export { u as useReducerAsync };